import Constants from '../Constants';
import * as Helpers from '../Utilities/Common';
import { normalizeData } from '../Schemas';
import Permissions from '../Utilities/Permissions';
import { changeStats, getStats } from './DashboardActions';
import { toggleModal } from './ModalActions';


const { GET_JOBS, JOB_SUBMITTED, JOB_LOADING, DELETE_JOB, ADD_JOB, ADD_JOB_FAIL, UPDATE_JOB, UPDATE_JOB_FAIL, RESET_JOBS_ALERT } = Constants;

export const getJobs = (token, newQuery = {}, append = true) => async (dispatch, getState) => {
    // -----> Check if the page is available in the store ... save a request.
    let query = { page: 1 };

    if(newQuery !== false){
        query = append ? { ...getState().jobStore.query, ...newQuery } : newQuery;
    }
    
    dispatch(jobLoading());
    
    dispatch(getStats(token, query));

    const response = await Helpers.makeRequest(token,'JOBS','GET','',query);

    if(response.result){
        const normalizedData = normalizeData(response.data,"jobs");
        dispatch({ type: GET_JOBS, payload: { data: normalizedData, query: query } });
        dispatch({ type: RESET_JOBS_ALERT, payload: true });
    }

}

export const resetAlert = () => (dispatch) => {
    dispatch({ type: RESET_JOBS_ALERT, payload: true });
}

export const jobLoading = () => ({ type: JOB_LOADING, payload: true });

export const deleteJob = (token,id) => async (dispatch, getState) => {
    const { jobStore: { jobs: { [id]: { status } } } } = getState();

    const response = await Helpers.makeRequest(token,'JOBS','DELETE','','',id);
    
    if(response.result){
        dispatch({ type: DELETE_JOB, payload: id });
        dispatch(changeStats(status, false));
    }
}

const addExtraFields = (formData, data, permission, method = 'post') => {
    const {status,assigned_to,priority} = data;
    const permissions = new Permissions(permission);
    !permissions.blockedField('status','jobs',method) && status !== undefined?formData.status = status:null;
    !permissions.blockedField('assigned_to','jobs',method) && assigned_to !== undefined?formData.assigned_to = assigned_to:null;
    !permissions.blockedField('priority','jobs',method) && priority !== undefined?formData.priority = priority:null;

    return formData;
}

export const addJob = (token,data,permissions) => async (dispatch) => {
    const { type: type_id, location: location_id, subLocation: sub_location_id, locationMeta: location_meta, comment, HS, problem, image, quick_add = false } = data;
    let formData = { type_id, location_id, sub_location_id, location_meta, comment, HS, problem, image };
    formData = addExtraFields(formData, data, permissions);
    quick_add ? formData.quick_add = true: null;
    dispatch({ type: JOB_SUBMITTED, payload: true });

    const response = await Helpers.makeRequest(token,'JOBS','POST',formData);

    if(response.result){
        //dispatching action ADD_JOB causes the previous jobs state to refresh
        dispatch({ type: ADD_JOB, payload: true });
        dispatch(toggleModal("jobs","add"));
        //getting jobs again. Doing this on purpose
        dispatch(getJobs(token));
    }else{
        dispatch({ type: ADD_JOB_FAIL, payload: response.data });
    }

}

export const editJob = (token, data, permissions, id) => async (dispatch, getState) => {
    const { jobStore: { jobs: { [id]: { status: oldStatus } } } }= getState();
    const { type: type_id, location: location_id, subLocation: sub_location_id, locationMeta: location_meta, comment, HS, problem, image } = data;
    let formData = { type_id, location_id, sub_location_id, location_meta, comment, HS, problem };

    if(!Helpers.is_url(image)) formData.image = image;

    dispatch({ type: JOB_SUBMITTED, payload: true });

    formData = addExtraFields(formData, data, permissions, 'put');

    const response = await Helpers.makeRequest(token,'JOBS','PUT',formData,'',id);
    
    if(response.result){
        const { data: { job, job: { status: newStatus } } } = response;
        dispatch({ type: UPDATE_JOB, payload: job });
        dispatch(toggleModal("jobs","edit"));
        dispatch(resetAlert());
        if(oldStatus !== newStatus){
            dispatch(changeStats(oldStatus,false));
            dispatch(changeStats(newStatus,true));
        }
    }else{
        dispatch({ type: UPDATE_JOB_FAIL, payload: response.data });
    }
}





// WEBPACK FOOTER //
// ./src/Actions/JobActions.js